import { useTranslation } from 'react-i18next';
import { type Option, RadioOption } from './radio-option';

type P<T> = {
  disabled?: boolean;
  onSelect: (key: T) => void;
  options: Array<Option<T>>;
  selected: T;
  title?: string;
};

/** @deprecated This is an old component, it is not used in the new design system */
const RadioGroupWithOptions = <T extends string>({ disabled, onSelect, options, selected, title }: P<T>) => {
  const { t } = useTranslation();

  return (
    <div className="radio-group-with-options">
      {title ? <span className="radio-group-with-options-title">{t(title)}</span> : null}
      {options.map((option) => (
        <RadioOption<T>
          checked={option.key === selected}
          disabled={disabled}
          key={option.key}
          onSelect={() => {
            onSelect(option.key);
          }}
          option={option}
        />
      ))}
    </div>
  );
};

export default RadioGroupWithOptions;
